module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"titleAdminPage\">My Account</div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <app-credit-usage *ngIf=\"companyId\" [companyId]=\"companyId\" [users]=\"users\"></app-credit-usage>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-12 col-lg-4 col-md-6\">\n      <app-user-info></app-user-info>\n    </div>\n    <div class=\"col-12 col-lg-4 col-md-6\">\n      <app-quota-info></app-quota-info>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/components/myaccount/my-account.component.html
// module id = 1411
// module chunks = 0